<template>
  <el-card header="申诉基础信息">
    <el-form
      ref="form"
      :model="baseParams"
      :rules="rules"
      label-width="110px"
      inline
    >
      <el-form-item label="申诉方名称" prop="appealName">
        <el-input
          placeholder="请输入"
          v-model="baseParams.appealName"
          class="form-field"
          clearable
          :disabled="handleDisable('appealName')"
        ></el-input>
      </el-form-item>
      <el-form-item label="申诉类型" prop="applicationType">
        <el-select
          v-model="baseParams.applicationType"
          class="form-field"
          placeholder="请选择申诉类型"
          :disabled="handleDisable('applicationType')"
          @change="handleApplicationTypeChange"
        >
          <el-option
            v-for="(name, id) in appealTypeMap"
            :key="+id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申诉一级场景" prop="bussType">
        <el-select
          v-model="baseParams.bussType"
          class="form-field"
          placeholder="请选择申诉一级场景"
          :disabled="handleDisable('bussType')"
          @change="handleBussTypeChange"
        >
          <el-option
            v-for="(name, id) in levelOneAppealMap"
            :key="+id"
            :label="name"
            :value="+id"
            :disabled="disableLevelOne(+id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申诉二级场景" prop="complaintType">
        <el-select v-model="baseParams.complaintType" class="form-field" placeholder="请选择申诉二级场景" :disabled="handleDisable('complaintType')">
          <el-option
            v-for="(name, id) in levelTwoAppealMap"
            :key="+id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!edit" label="申诉人">
        <el-input v-model="baseParams.applicationUser" class="form-field" placeholder="请输入申诉人" :disabled="handleDisable('applicationUser')"></el-input>
      </el-form-item>
      <el-form-item v-if="!edit" label="申诉发起时间">
        <el-date-picker
          v-model="baseParams.applicationTime"
          type="datetime"
          placeholder="请选择申诉发起时间"
          value-format="yyyy-MM-dd"
          class="long-form-field"
          :disabled="handleDisable('applicationTime')"
        ></el-date-picker>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import {
  LEVEL_ONE_APPEAL,
  appealTypeMap,
  getLevelOneMap,
  getLevelTwoMap,
} from './const'

export default {
  name: 'AppealBaseForm',
  props: {
    baseParams: {
      type: Object,
      required: true
    },
    disableFields: {
      type: Array,
      default: () => []
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      appealTypeMap,
      rules: {
        appealName: [{ required: true, message: '请输入申诉方名称', trigger: 'blur' }],
        applicationType: [{ required: true, message: '请选择申诉类型', trigger: 'change' }],
        bussType: [{ required: true, message: '请选择申诉一级场景', trigger: 'change' }],
        complaintType: [{ required: true, message: '请选择申诉二级场景', trigger: 'change' }],
      }
    }
  },
  computed: {
    levelOneAppealMap() {
      return getLevelOneMap(this.baseParams.applicationType)
    },
    levelTwoAppealMap() {
      return getLevelTwoMap(this.baseParams.applicationType, this.baseParams.bussType)
    }
  },
  methods: {
    handleApplicationTypeChange(val) {
      this.baseParams.bussType = +Object.keys(this.levelOneAppealMap)[0]
      this.handleBussTypeChange(this.baseParams.bussType)
    },
    handleBussTypeChange(val) {
      this.baseParams.complaintType = +Object.keys(this.levelTwoAppealMap)[0]
    },
    handleDisable(key) {
      return !this.edit || this.disableFields.includes(key)
    },
    disableLevelOne(val) {
      return [LEVEL_ONE_APPEAL.WHITE_LIST.code].includes(val)
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, error) => {
          if (valid) {
            resolve()
          } else {
            reject(Object.values(error)[0][0])
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-field {
  width: 210px;
}
.long-form-field {
  width: 380px;
}
</style>
